<template>
  <footer class="main-footer d-flex p-2 px-3 bg-white border-top">
    <div :class="[contained ? 'container' : 'container-fluid']">
      <div class="row">
        <ul class="nav">
          <d-link class="nav-link" to="/terms">{{ $t("dashfooter.terms") }}</d-link>
          <d-link class="nav-link" to="/privacy">{{ $t("dashfooter.privacy") }}</d-link>
          <a
            class="nav-link"
            href="javascript:window.Metomic('ConsentManager:show')"
          >{{ $t("dashfooter.cookies") }}</a>
          <a
            class="nav-link"
            target="_blank"
            href="https://spring.kampsite.co"
          >{{ $t("dashfooter.featurerequest") }}</a>
          <a
            class="nav-link"
            target="_blank"
            href="https://enzymelabs.co"
          >{{ $t("dashfooter.about") }}</a>
        </ul>
        <span class="copyright ml-auto my-auto mr-2">© Copyright Spring.app</span>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  components: {},
  name: "main-footer",
  props: {
    contained: {
      type: Boolean,
      default: false
    }
  }
};
</script>